// dataService-v2.ts - Backward compatible wrapper around real services
// This maintains the same interface as the old dataService but uses real backend services

import { serviceService } from '@/shared/services/serviceService';
import { quoteService } from '@/shared/services/quoteService';
import { invoiceService } from '@/shared/services/invoiceService';
import { expenseService } from '@/shared/services/expenseService';
import { realDataService } from '@/shared/services/realDataService';

// Create the new dataService with real backend implementation
export const dataService = {
  // Use realDataService as the main implementation
  ...realDataService,

  // --- SERVICES ---
  ...serviceService,

  // --- JOBS (Legacy - now maps to Quotes) ---
  ...quoteService,

  // --- INVOICES ---
  ...invoiceService,

  // --- EXPENSES ---
  ...expenseService,

  // --- ADMIN METHODS ---
  // NOTE: Admin methods have been removed as they used mock localStorage data
  // Use the new AdminRepository instead: repositories.admin.*()

  // --- EMAIL METHODS ---
  // NOTE: Email service methods have been removed as they used mock localStorage data
  // Email functionality should use the real email services in @/shared/services/email/

  // Flag to indicate we're using real services
  isUsingRealServices: true
};